import React from 'react';

const CollectionCardView = ({ bgColor, headTitle, children }) => {
  return (
    <div className="card">
      <div className="card-header card-header-text" data-background-color={bgColor}>
        <h6 className="card-title pb-0 mb-0 text-capitalise">{headTitle}</h6>
      </div>

      <div className="card-content">{children}</div>
    </div>
  );
};

export default CollectionCardView;
